import { useTranslation } from 'react-i18next';
import { IoCloseOutline, IoSearchOutline } from 'react-icons/io5';
import './coach-athlete-search.css';

export function CoachAthleteSearch({ value, onChange }: {
  value: string;
  onChange: (value: string) => void;
}) {
  const { t } = useTranslation();
  return (
    <div className="coach-athlete-search">
      <IoSearchOutline aria-hidden="true" size={16} />
      <input
        type="search"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={t('assistant.searchAthletes')}
        aria-label={t('assistant.searchAthletes')}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="none"
        spellCheck={false}
      />
      {value && <button type="button" onClick={() => onChange('')}
        aria-label={t('calendar.hint.clear')}>
        <IoCloseOutline aria-hidden="true" size={16} />
      </button>}
    </div>
  );
}
